import type { SlateBlock, SlateTopBlock } from '@atlas/renderer';

export default function isTopLevelBlock(block: SlateBlock): block is SlateTopBlock {
    return (TOP_LEVEL_BLOCK_TYPES as Array<SlateBlock['type']>).includes(block.type);
}

// #region Helpers

export const TOP_LEVEL_BLOCK_TYPES: Array<SlateTopBlock['type']> = [
    'paragraph',
    'block-quote',
    'callout',
    'heading-one',
    'heading-two',
    'heading-three',
    'code-block',
    'numbered-list',
    'bulleted-list',
    'table',
    'horizontal-line',
    'image',
    'video',
    'video-embed',
    'embed',
];

// #endregion

// #region Types

export type { SlateTopBlock };

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isTopLevelBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
